import { Injectable } from '@angular/core';
import {User} from '../classes/user';
import {Student} from '../classes/student';
import { Assignment, AssignmentStudent } from '../classes/assignment';

enum localStorageKeys {
  currentUser = 'currentUser',
  students = 'students',
  assignments = 'assignments',
  learningOutcomes = 'learningOutcomes',
}

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() {}

  public setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public getItem(key: string): any {
    console.log("getItem: " + key);
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return null;
  }

  public setUser(user: User): void {
    this.setItem(localStorageKeys.currentUser, user);
  }

  public setStudents(students: Student[]): void {
    this.setItem(localStorageKeys.students, students);
  }

  public setAssignments(assignments: any[]): void {
    this.setItem(localStorageKeys.assignments, assignments);
  }

  public setLearningOutcomes(learningOutcomes: any[]): void {
    this.setItem(localStorageKeys.learningOutcomes, learningOutcomes);
  }

  public getUser(): User | null {
    const user =  this.getItem(localStorageKeys.currentUser);
    if (user) {
      const currentUser = new User();
      currentUser.setUser(user);
      return currentUser;
    }
    return null;
  }

  public getStudents(): Student[] {
    const students: Student[] = this.getItem(localStorageKeys.students);
    if (students) {
      const studentObjects: Student[] = [];
      students.forEach((student: any) => {
        const studentObj = new Student();
        studentObj.setStudent(student);
        studentObjects.push(studentObj);
      });
      return studentObjects;
    }
    return [];
  }

  public getAssignments(): any[] {
    const assignments = this.getItem(localStorageKeys.assignments);
    if (assignments) {
      const assignmentObjects: any[] = [];
      assignments.forEach((assignment: any) => {
        let assignmentStudents: AssignmentStudent[] = [];
        assignment.students.forEach((student: AssignmentStudent) => {
          const studentObj:AssignmentStudent = { scores: student.scores, student: new Student()};
          studentObj.student.setStudent(student.student);
          assignmentStudents.push(studentObj);
        });

        const assignmentObj = new Assignment();
        assignmentObj.setAssignment({
          requestKey: assignment.requestKey,
          name: assignment.name,
          dateAdded: assignment.dateAdded,
          createdBy: assignment.createdBy,
          learningOutcomes: assignment.learningOutcomes,
          students: assignmentStudents
        });
        assignmentObjects.push(assignmentObj);
      });
      return assignmentObjects;
    }
    return [];
  }

  public getLearningOutcomes(): any[] {
    const learningOutcomes = this.getItem(localStorageKeys.learningOutcomes);
    if (learningOutcomes) {
      return learningOutcomes;
    }
    return [];
  }

  public clearUser(): void {
    this.removeItem(localStorageKeys.currentUser);
    this.removeItem(localStorageKeys.students);
    this.removeItem(localStorageKeys.assignments);
    this.removeItem(localStorageKeys.learningOutcomes);
  }

  public clear(): void {
    localStorage.clear();
  }
}
